import React from 'react'
import ReactSelect from 'react-select'
import styles from './TextTransformInput.module.css'

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--dark-gray)',
    fontFamily: 'var(--sans-serif)',
    fontSize: 'var(--size-font-input)',
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)',
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)',
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)',
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const TextTransformInput = ({ name, value, onChange }) => {
  const options = [
    { value: 'none', label: 'Aucune transformation' },
    { value: 'uppercase', label: 'MAJUSCULES' },
  ]

  const handleChange = (selectedOption) => {
    onChange({
      target: {
        name: name,
        value: selectedOption ? selectedOption.value : '',
      },
    })
  }

  const selectedOption = options.find((option) => option.value === value)

  return (
    <div className={styles.container}>
      <ReactSelect
        value={selectedOption}
        onChange={handleChange}
        options={options}
        styles={customStyles}
      />
    </div>
  )
}

export default TextTransformInput
